const OnTopOfSpaghetti = [
	'[Verse 1]',
	'On top of spaghetti,',
	'All covered with cheese,',
	'I lost my poor meatball,',
	'When somebody sneezed.',
	'',
	'[Verse 2]',
	'It rolled off the table,',
	'And onto the floor,',
	'And then my meatball,',
	'Rolled right out the door.',
	'',
	'[Verse 3]',
	'It rolled onto the sidewalk,',
	'Then into the street,',
	'And now my poor meatball,',
	'Is too dirty to eat.',
];

export default OnTopOfSpaghetti;
